export default (axios, widgetId) => axios.post(`/widget/${widgetId}/test-event`);
